{
    "eyebrow": "User guide",
    "title": "Your guide",
    "subtitle": "Written for what you do here. Read it end to end on your first day, or find the one thing you need on your third.",
    "reading_time": "{{count}} min read",
    "chapters_count": "{{count}} chapters",
    "start_reading": "Start reading",
    "print": "Print",
    "contents": "Contents",
    "progress": "{{done}} of {{total}} read",
    "reset_progress": "Start again",
    "mark_read": "Mark as read",
    "marked_read": "Read",
    "step": "Step {{number}}",
    "open_screen": "Open this screen",
    "back_to_top": "Back to top",
    "tone": {
        "note": "Note",
        "tip": "Tip",
        "caution": "Worth knowing"
    },
    "glossary": {
        "title": "Words that mean something specific here",
        "subtitle": "Ten terms that are used precisely in this platform, and are worth reading once.",
        "search": "Filter terms",
        "search_placeholder": "Type a word",
        "empty": "No term matches that."
    },
    "faq": {
        "title": "Questions from the first week",
        "subtitle": "The ones people actually ask, answered plainly."
    },
    "other_roles": {
        "title": "Another role's guide",
        "subtitle": "Each role is given a different guide. A manager who cannot see what their officers were told cannot hold them to it.",
        "read": "Read this guide",
        "yours": "Yours",
        "back_to_mine": "Back to my guide",
        "viewing": "You are reading the guide written for {{role}}."
    },
    "footer": {
        "title": "When you would rather click than read",
        "body": "The showcase is a four-minute tour of the screens your role uses, and the API reference documents the interface behind them.",
        "showcase": "Take the tour",
        "api": "API reference"
    },
    "invitation": {
        "title": "Your guide is ready",
        "body": "A guide written for your role — what the platform is for you, how your working day runs in it, and the screens you will live in. About six minutes.",
        "action": "Open my guide",
        "dismiss": "Not now"
    }
}
